// Printable warehouse pick list for an order's material requirements.
const esc = (s) => String(s ?? "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");

export function buildPickListHtml(data, plantName = "H. K. INDUSTRIES (D-54)") {
  const rows = data.totals
    .map((t) => {
      const short = (t.missing || 0) > 0;
      return `<tr${short ? ' class="short"' : ""}>
        <td class="chk">☐</td>
        <td class="mono">${esc(t.sku)}</td>
        <td>${esc(t.name)}</td>
        <td class="num">${t.required_remaining?.toLocaleString("en-IN")} ${esc(t.unit)}</td>
        <td class="num">${t.in_stock?.toLocaleString("en-IN")} ${esc(t.unit)}</td>
        <td class="num">${short ? `−${t.missing.toLocaleString("en-IN")} ${esc(t.unit)}` : "OK"}</td>
      </tr>`;
    })
    .join("");

  return `<!DOCTYPE html><html><head><title>Pick List — ${esc(data.order_code)}</title><style>
    body { font-family: Arial, Helvetica, sans-serif; color: #0f172a; margin: 32px; }
    h1 { font-size: 18px; margin: 0 0 2px; }
    .sub { color: #64748b; font-size: 12px; margin-bottom: 20px; }
    table { width: 100%; border-collapse: collapse; font-size: 12px; }
    th { text-align: left; text-transform: uppercase; font-size: 10px; letter-spacing: 0.05em;
         color: #64748b; border-bottom: 2px solid #0f172a; padding: 6px 8px; }
    td { border-bottom: 1px solid #e2e8f0; padding: 8px; }
    td.num, th.num { text-align: right; font-variant-numeric: tabular-nums; }
    td.mono { font-family: "Courier New", monospace; }
    td.chk { font-size: 16px; width: 28px; }
    tr.short td { background: #fef2f2; color: #b91c1c; }
    .foot { margin-top: 28px; font-size: 11px; color: #64748b; display: flex; justify-content: space-between; }
    .sign { margin-top: 40px; display: flex; gap: 60px; font-size: 11px; }
    .sign div { border-top: 1px solid #94a3b8; padding-top: 4px; width: 200px; }
  </style></head><body>
    <h1>Warehouse Pick List — ${esc(plantName)}</h1>
    <p class="sub">${esc(data.order_code)} · ${esc(data.product_name)} · ${Number(data.target_quantity).toLocaleString("en-IN")} units
      (${Number(data.produced_quantity).toLocaleString("en-IN")} produced, quantities below cover the remaining units)
      · printed ${new Date().toLocaleString("en-IN")}</p>
    <table>
      <thead><tr><th></th><th>SKU</th><th>Material</th><th class="num">Pick Qty</th><th class="num">In Stock</th><th class="num">Coverage</th></tr></thead>
      <tbody>${rows}</tbody>
    </table>
    <div class="foot"><span>Rows highlighted in red cannot be fully covered by current stock.</span><span>H. K. INDUSTRIES · Production Planning</span></div>
    <div class="sign"><div>Picked by / date</div><div>Checked by / date</div></div>
  </body></html>`;
}

function printHtml(html) {
  const frame = document.createElement("iframe");
  frame.setAttribute("aria-hidden", "true");
  frame.style.cssText = "position:fixed;right:0;bottom:0;width:0;height:0;border:0;";
  frame.srcdoc = html;
  frame.onload = () => {
    try {
      frame.contentWindow.focus();
      frame.contentWindow.print();
    } finally {
      setTimeout(() => frame.remove(), 1000);
    }
  };
  document.body.appendChild(frame);
}

export function printPickList(data, plantName) {
  printHtml(buildPickListHtml(data, plantName));
}
